import { inject, observer } from "mobx-react";
import * as React from "react";
import PaymentFailedNotice from "./payment-notice/PaymentFailedNotice.mjs";
import PaymentSuccessfulNotice from "./payment-notice/PaymentSuccessfulNotice.mjs";
class PaymentFinalized extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const { onFinalStatus } = this.props.finalizePaymentProps || {};
    onFinalStatus && onFinalStatus(this.props.paymentStore.paymentStatus);
  }
  render() {
    const paymentStatus = this.props.paymentStore.paymentStatus;
    const { translate, translateHtml } = this.props.translateStore;
    const { onCompletedButton, paymentSuccessInfo, onCloseButton } = this.props.finalizePaymentProps || {};
    if (paymentStatus === "COMPLETED") {
      return /* @__PURE__ */ React.createElement(
        PaymentSuccessfulNotice,
        {
          title: translateHtml("payment.mtasku.payment-successful"),
          closeButtonLabel: translate("payment.close-button"),
          onCloseButton: onCompletedButton,
          paymentSuccessInfo
        }
      );
    }
    if (["ERROR", "REJECTED", "NOT_FOUND"].includes(paymentStatus)) {
      return /* @__PURE__ */ React.createElement(
        PaymentFailedNotice,
        {
          title: translate("payment.mtasku.error-title"),
          description: paymentStatus === "REJECTED" ? translate("payment.card.payment-rejected") : translate("payment.card.error-description"),
          closeButtonLabel: translate("payment.close-button"),
          onCloseButton,
          retryButtonLabel: translate("payment.try-again-button"),
          onRetryButton: paymentStatus !== "NOT_FOUND" ? () => this.retryPayment() : void 0
        }
      );
    }
  }
  retryPayment() {
    const { onRetryButton } = this.props.finalizePaymentProps || {};
    onRetryButton && onRetryButton();
    this.props.paymentStore?.setPaymentStatus("RETRY");
  }
}
const PaymentFinalized$1 = inject("translateStore", "paymentStore")(observer(PaymentFinalized));
export {
  PaymentFinalized$1 as default
};
